export const servicesOptions = [
  'Investment Planning',
  'Tax Consultation',
  'Retirement Planning',
  'Debt Management',
]

export const insurancePlanOptions = ['Ayuvu Bharosa', 'FHPL', 'Other']

export const roomCategoryOptions = [
  {
    label: 'General Ward',
    value: 'general',
  },
  {
    label: 'Emergency Ward',
    value: 'emergency',
  },
]

export const errorMessages = {
  required: 'This field is required',
  minLength: (field: string, min: number) =>
    `${field} must be at least ${min} characters`,
  minSelection: (field: string, min: number) =>
    `Please select at least ${min} ${field}`,
  invalidDate: 'Invalid date',
}
